
jQuery(function ($) {
    // console.log('Immersive Cards on DOM');
    
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.error('GSAP or ScrollTrigger not loaded');
        return;
    }
    
    gsap.registerPlugin(ScrollTrigger);
    
    $('.wp-block-jormi-blocks-immersive-cards').each(function() {
        const container = $(this);
        const statCards = container.find('.wp-block-jormi-blocks-card.card-stat');
        const badgeCards = container.find('.wp-block-jormi-blocks-card.card-badge');
        
        // Function to set text color with !important. Required to override WP's inline styles.
        const setTextColor = (elements, color) => {
            elements.attr('style', function(i, style) {
                return (style || '') + `color: ${color} !important;`;
            });
        };

        if (statCards.length) {
            const setLightTheme = (card) => {
                gsap.to(card, {
                    backgroundColor: '#ffffff',
                    duration: 0.3
                });
                gsap.to(card.find('img'), {
                    filter: 'invert(1)',
                    duration: 0.3
                  });
                setTextColor(card.find('h1,h2,h3,h4,h5,h6,p,a'), '#000000');
            };
        
            const setDarkTheme = (card) => {
                gsap.to(card, {
                    backgroundColor: '#000000',
                    duration: 0.3
                });
                gsap.to(card.find('img'), {
                    filter: 'invert(0)',
                    duration: 0.3
                  });
                setTextColor(card.find('h1,h2,h3,h4,h5,h6,p,a'), '#ffffff');
            };
        
            // Set default states for cards and first card
            statCards.each(function() {
                setDarkTheme($(this));
            });
            setLightTheme(statCards.first());
        
            statCards.slice(1).each(function(index) {
                const card = $(this);
                
                ScrollTrigger.create({
                    trigger: card,
                    start: 'top center',
                    end: 'bottom center',
                    toggleActions: 'play none none reverse',
                    onEnter: () => {
                        statCards.each(function() {
                            setDarkTheme($(this));
                        });
                        setLightTheme(card);
                    },
                    onLeaveBack: () => {
                        const prevCard = statCards.eq(index);
                        // Revert all to dark theme
                        statCards.each(function() {
                            setDarkTheme($(this));
                        });
                        // Set previous card to light theme
                        setLightTheme(prevCard);
                    }
                });
            });

        } else if (badgeCards.length) {

            const setLightTheme = (card) => {
                const badge = card.find('.badge');
                const link = card.find('.wp-element-button');
                gsap.to(card, {
                    backgroundColor: '#ffffff',
                    duration: 0.3
                });
                gsap.set(badge, {
                    backgroundColor: '#000000',
                    color: '#ffffff'
                });
                link.removeClass('has-white-color').addClass('has-black-color'); // Needed for the link's pseudo element
                setTextColor(card.find('h1,h2,h3,h4,h5,h6,a'), '#000000');
                setTextColor(card.find('p,li'), '#666666');
            };

            const setDarkTheme = (card) => {
                const badge = card.find('.badge');
                const link = card.find('.wp-element-button');
                
                gsap.to(card, {
                    backgroundColor: '#000000',
                    duration: 0.3
                });
                gsap.set(badge, {
                    backgroundColor: '#ffffff',
                    color: '#000000'
                });
                link.removeClass('has-black-color').addClass('has-white-color');
                setTextColor(card.find('h1,h2,h3,h4,h5,h6,p,a,li'), '#ffffff');
            };

            // Set default states for cards and first card
            badgeCards.each(function() {
                setLightTheme($(this));
            });
            setDarkTheme(badgeCards.first());

            badgeCards.slice(1).each(function(index) {
                const card = $(this);
    
                ScrollTrigger.create({
                    trigger: card,
                    start: 'top center',
                    end: 'bottom center',
                    toggleActions: 'play none none reverse',
                    onEnter: () => {
                        badgeCards.each(function() {
                            setLightTheme($(this));
                        });
                        setDarkTheme(card);
                    },
                    onLeaveBack: () => {
                        const prevCard = badgeCards.eq(index);
                        // Revert all to light theme
                        badgeCards.each(function() {
                            setLightTheme($(this));
                        });
                        // Set previous card to dark theme
                        setDarkTheme(prevCard);
                    }
                });
            });
        }

    });
});